import React, {useState} from 'react'
import { Drawer } from 'antd'
import UtilityDrawerHeader from './UtilityDrawerHeader'
import UtilityDrawerFooter from './UtilityDrawerFooter'
import UtilityDrawerContent from './UtilityDrawerContent'

const UtilityFloatingDrawer = ({ id, visible, onClose, leftPosition }) => {
  const [isMinimized, setIsMinimized] = useState(false);
  
  const headerTitle = 'Utility Header';

  const handleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  return (
    <>
      <Drawer
        title={<UtilityDrawerHeader onClose={onClose} onMinimize={handleMinimize} headerTitle={headerTitle} />}
        placement="bottom"
        closable={false}
        onClose={onClose}
        open={visible}
        zIndex={1002}   // higher than sidebar
        mask={false}
        height={isMinimized ? 49 : 360}
        style={{
          borderRadius: '6px 6px 0 0',
          overflow: 'hidden',
        }}
        footer={<UtilityDrawerFooter onClose={onClose} />}
        styles={{
          wrapper: {
            position: 'fixed',
            width: '360px',
            margin: '0 auto',
            boxShadow: '0 -4px 6px rgba(0, 0, 0, 0.1)',
            left: `${leftPosition}px`,
            borderRadius: '6px 6px 0 0',
          },
        }}
      >
        {<UtilityDrawerContent />}
      </Drawer>
    </>
  )
}

export default UtilityFloatingDrawer